<template>
  <v-card outlined>
    <v-container class="px-4 py-1" fluid>
      <v-card flat>
        <v-card-title class="py-1">
          {{ $t('ELE0028') }}
        </v-card-title>
        <v-row dense class="mb-1">
          <v-col cols="4">
            <TextFieldRef v-if="isActioned" :label="$t('ELE0184')" v-model="searchCondition.saNo" />
            <TextFieldInput v-else :label="$t('ELE0184')" v-model="searchCondition.saNo" />
          </v-col>
          <v-spacer />
          <v-col cols="8" v-if="!isModal">
            <span d-flex flex-row space-between>
              <BtnSearch class="ml-4" @click="onClickSearch" :disabled="isActioned || searchCondition.saNo == ''" />
              <BtnNew class="mx-4" @click="onClickNew" :disabled="isActioned || searchCondition.saNo != ''" />
              <BtnReset class="mx-4" @click="onClickResetForm" :disabled="!isActioned" />
            </span>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-container v-if="form != null" fluid>
      <v-card outlined>
        <v-row v-if="form.statusCd != ''" class="px-4 py-2">
          <v-col cols="2">
            <TextFieldRef :label="$t('ELE0217')" :value="getEnumlang('SaApprovalStatusCd.', form.statusCd)" />
          </v-col>
          <v-col cols="4">
            <TextFieldRef :label="$t('ELE0220')" :value="form.currentRouteName" />
          </v-col>
          <v-col cols="2">
            <TextFieldRef :label="$t('ELE0352')" :value="form.orgSaNo" />
          </v-col>
          <v-col cols="3">
            <BtnCopy class="mx-4" @click="onClickCopy" />
            <Btn :label="$t('ELE0357')" @click="onClickExtend" icon="mdi-source-branch" />
          </v-col>
          <v-col cols="1">
            <BtnInvalid :disabled="!canInvalid" @click="onClickInvalid" />
          </v-col>
        </v-row>
        <v-row v-else-if="form.orgSaNo" class="px-4 py-2">
          <v-col cols="2">
            <TextFieldRef :label="$t('ELE0352')" :value="form.orgSaNo" />
          </v-col>
        </v-row>
        <v-row class="px-4 py-2">
          <v-col cols="6">
            <TextFieldRef :label="$t('ELE0543')" :value="form.wfRemarks"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <SaRequestSupplierForm
              :form="form"
              :canApproveEpson="canApproveEpson"
              :canReturnEpson="canReturnEpson"
              :canEditEpson="canEditEpson"
              @reset="onClickResetForm"
              @research="search"
              :isExtend="isExtend"
              :isCmsRoute="isCmsRoute"
            />
          </v-col>
        </v-row>
        <v-row v-if="isProcessedEpsonRoute && !isSupplierRoute" dense>
          <v-col>
            <SaRequestEpsonForm
              :form="form"
              :canApproveEpson.sync="canApproveEpson"
              :canReturnEpson.sync="canReturnEpson"
              :canEditEpson.sync="canEditEpson"
              :isCmsRoute="isCmsRoute"
              @reset="onClickResetForm"
            />
          </v-col>
        </v-row>
      </v-card>
      <ConfirmDialog
        :dialog="isConfirmDialog"
        :confirmWord="$t('MSG0181')"
        :btnLabel="$t('ELE0537')"
        btnColor="error"
        @cancel="onCancel"
        @proceed="onProceed"
      />
    </v-container>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { SaWfCheckedCat, SaApprovalStatusCd, Role } from '@/enum'
import moment from 'moment'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'

import Btn from '@/components/atoms/base/button/Btn'
import BtnInvalid from '@/components/atoms/button/BtnInvalid'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import BtnNew from '@/components/atoms/button/BtnNew'
import BtnReset from '@/components/atoms/button/BtnReset'
import BtnCopy from '@/components/atoms/button/BtnCopy'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'

import SaRequestSupplierForm from '@/components/organisms/terminal/form/SaRequestSupplierForm'
import SaRequestEpsonForm from '@/components/organisms/terminal/form/SaRequestEpsonForm'
import ConfirmDialog from '@/components/organisms/common/dialog/ConfirmDialog'

export default {
  name: 'SaRequestForm',

  mixins: [APIUtils, Message, Loading, DateUtils],

  components: {
    Btn,
    BtnInvalid,
    BtnSearch,
    BtnNew,
    BtnReset,
    BtnCopy,
    TextFieldInput,
    TextFieldRef,
    SaRequestSupplierForm,
    SaRequestEpsonForm,
    ConfirmDialog,
  },

  props: {
    propsSaNo: {
      type: String,
      required: false,
      default: '',
    },
    isModal: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      isConfirmDialog: false,
      searchCondition: {
        saNo: '',
      },
      form: null,
      isActioned: false,
      canApproveEpson: false,
      canReturnEpson: false,
      canEditEpson: false,
    }
  },

  computed: {
    ...mapGetters(['isEpson']),
    isProcessedEpsonRoute: {
      // EPSONルートで処理したか判定
      get() {
        let result = false
        if (this.form.epsonRoutes) {
          if (
            this.form.statusCd == SaApprovalStatusCd.SUPPLIER_APPROVED ||
            (this.form.epsonRoutes.length > 0 &&
              this.form.epsonRoutes.some((e) => e.checkers.some((checker) => checker.result !== null)))
          ) {
            result = true
          }
        }
        return result
      },
    },
    isSupplierRoute: {
      get() {
        let result = false
        if (
          this.form &&
          (this.form.statusCd == SaApprovalStatusCd.TEMP_SAVE ||
            this.form.statusCd == SaApprovalStatusCd.SUPPLIER_APPLYING ||
            this.form.cmsStatusCd == SaApprovalStatusCd.TEMP_SAVE ||
            this.form.cmsStatusCd == SaApprovalStatusCd.SUPPLIER_APPLYING)
        ) {
          result = true
        }
        return result
      },
    },
    isExtend: {
      get() {
        let result = false
        if (this.form && this.form.orgSaNo != null) {
          result = true
        }
        return result
      },
    },
    canInvalid: {
      get() {
        return (
          this.form.statusCd == SaApprovalStatusCd.APPROVED &&
          this.isEpson &&
          this.$store.getters.hasRole(Role.SA_APPROVE)
        )
      },
    },
    isCmsRoute: {
      // Counter Measuresであるか
      get() {
        let result = false
        if (this.form.cmsStatusCd) {
          result = true
        }
        return result
      },
    },
  },

  methods: {
    getEnumlang(key, value) {
      // langのenumからメッセージ取得
      let lang = ''
      if (value) {
        lang = this.$t(key + value)
      }
      return lang
    },

    async search(saNo) {
      this.searchCondition.saNo = saNo
      await this.onClickSearch()
    },

    async onClickSearch() {
      try {
        this.startLoading()
        this.form = null
        this.isActioned = false

        const params = {
          saNo: this.searchCondition.saNo,
          userCompanyCd: this.$store.getters.companyCd,
        }

        this.form = await API.get('/sa/info', params)
        this.isActioned = true
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0291') })))
      } finally {
        this.stopLoading()
      }
    },

    onClickNew() {
      this.form = {
        saNo: '',
        wfNo: null,
        wfVersionNo: null,
        statusCd: '',
        currentRouteName: '',
        requestCompanyCd: this.$store.getters.companyCd,
        requestCompanyCatCd: this.$store.getters.companyCatCd,
        requesterCd: this.$store.getters.userCd,
        acceptCompanyCd: '',
        accepterCd: '',
        productionCatCd: '',
        saReasonCds: [],
        reasonDtl: '',
        issueDate: moment().format('YYYY-MM-DD'),
        partCd: '',
        inspCharacRev: null,
        model: '',
        drawingRev: '',
        toolNoCav: '',
        stockQty: null,
        stockRemaining: null,
        nextAction: '',
        saLots: [],
        saDims: [],
        saApps: [],
        attachFiles: [],
        relatedLinks: [],
        currentRouteNo: 1,
        currentRouteDtlNo: 1,
        supplierRoute: {
          routeNo: 1,
          checkers: [
            {
              routeDtlNo: 1,
              checkerCd: this.$store.getters.userCd,
              checkedDatetime: '',
              remarks: '',
              checkedCat: SaWfCheckedCat.REQUEST,
            },
            {
              routeDtlNo: 2,
              checkerCd: '',
              checkedDatetime: '',
              remarks: '',
              checkedCat: SaWfCheckedCat.CHECK,
            },
            {
              routeDtlNo: 3,
              checkerCd: '',
              checkedDatetime: '',
              remarks: '',
              checkedCat: SaWfCheckedCat.APPROVE,
            },
          ],
        },
        extensionTime: 0,
        manufacturerCd: '',
      }
      this.isActioned = true
    },

    async onClickCopy() {
      try {
        this.startLoading()
        this.form = null

        const params = {
          saNo: this.searchCondition.saNo,
          userCompanyCd: this.$store.getters.companyCd,
          userCd: this.$store.getters.userCd,
        }

        this.form = await API.get('/sa/copy', params)
        this.searchCondition.saNo = ''
        this.isActioned = true
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0291') })))
      } finally {
        this.stopLoading()
      }
    },
    async onClickExtend() {
      try {
        this.startLoading()
        this.form = null

        const params = {
          saNo: this.searchCondition.saNo,
          userCompanyCd: this.$store.getters.companyCd,
          userCd: this.$store.getters.userCd,
          isExtend: true,
        }

        this.form = await API.get('/sa/copy', params)
        this.searchCondition.saNo = ''
        this.isActioned = true
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0291') })))
      } finally {
        this.stopLoading()
      }
    },

    onClickResetForm() {
      if (this.propsSaNo) {
        this.$emit('close')
      }
      Object.assign(this.$data, this.$options.data.call(this))
    },
    onClickInvalid() {
      this.isConfirmDialog = true
    },
    onCancel() {
      this.isConfirmDialog = false
    },
    async onProceed() {
      this.startLoading()
      try {
        this.isConfirmDialog = false
        const body = {
          wfNo: this.form.wfNo,
        }
        await API.post('/sa/epson/invalid', body)
        this.setSuccessMessage(this.$t('MSG0011', { p0: this.form.saNo }))
        this.onClickResetForm()
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.form.saNo })))
      } finally {
        this.stopLoading()
      }
    },
  },

  mounted() {
    if (this.propsSaNo) {
      this.search(this.propsSaNo)
    }
  },
}
</script>
